export enum FirmwareType {
  FIRMWARE_IOT = 'FIRMWARE_IOT',
  FIRMWARE_MACHINE_ECU = 'FIRMWARE_MACHINE_ECU',
  FIRMWARE_MACHINE_ELEVATOR = 'FIRMWARE_MACHINE_ELEVATOR'
}
